import { useState, useEffect, useContext } from 'react'
import { Box, Chip, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@material-ui/core'
import { format } from 'react-string-format'
import { useConfirm } from 'material-ui-confirm'
import { Context } from '../../../utils/context'
import { Strings } from '../../../assets/res/en'
import { profilesEndPoints, groupsEndPoints, merchantsEndPoints } from '../../../utils/endpoints'
import profileDataColumn from '../../../dataColumns/profileDataColumn'
import useTableIcons from '../../useTableIcons'
import useCommonMenus from '../common/useCommonMenus'
import { modules } from '../../../utils/config'
import permissionDataColumn from '../../../dataColumns/permissionDataColumn'
import useStyles from '../../useStyles'

let profilePermData = []
function useProfiles() {
    const { axios, authData, permissions, setPermissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`
    const classes = useStyles()
    const { columns, sytlingOptions } = profileDataColumn()
    const { tableIcons } = useTableIcons()
    const { groupsMenus, locationMenus, setGLObj } = useCommonMenus(axios)
    const confirm = useConfirm()
    const [profiles, setProfiles] = useState([])
    const [profilePermission, setProfilePermission] = useState({})
    const [endRoutes, setEndRoutes] = useState()
    const [sprofiles, setSearchProfiles] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchGroupsMenus, setSearchGroupMenus] = useState([])
    const [searchLocationMenus, setSearchLocationMenus] = useState([])
    const [filters, setFilters] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [modalHeader, setModalHeader] = useState({})
    const [modalContent, setModalContent] = useState({})
    const [modalActions, setModalActions] = useState([])
    const [modalFormResetKeys, setModalFormResetKeys] = useState([])
    const [modalTaskRunning, setModalTaskRunning] = useState(false)
    const [modalFormError, setModalFormError] = useState({})
    // Recordatorio "Don't forget to Edit Permissions" tras crear un perfil.
    const [showPermissionReminder, setShowPermissionReminder] = useState(false)
    const [searchData, setSearchData] = useState({
        sProfileName: "",
        sGroup: '',
        sLocation: ''
    })
    //check permission changes
    useEffect(() => {
        if (permissions && permissions.length > 0) {
            let proPermission = permissions.find(p => p.moduleId === modules.profiles.id)
            setProfilePermission(proPermission)
        }
    }, [permissions])
    //get Groups
    useEffect(() => {
        axios.get(groupsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    const groupItems = data.map(g => ({
                        text: g.description,
                        val: g.idGroup
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setSearchGroupMenus([
                        {
                            text: Strings.SEARCH_CASINO_GROUP,
                            val: ''
                        },
                        {
                            text: Strings.NO_GROUP,
                            val: 0
                        },
                        ...groupItems
                    ])
                }
            })
            .catch(err => err)
        axios.get(profilesEndPoints.getAllRoutes,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) setEndRoutes(res.data.data)
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //get Locations On Group Chnage
    useEffect(() => {
        setSearchLocationMenus([
            {
                text: Strings.SEARCH_CASINO_LOCATION,
                val: ''
            },
            {
                text: Strings.NO_LOCATION,
                val: 0
            },
        ])
        setSearchData(prevData => ({
            ...prevData,
            sLocation: ''
        }))
        if (searchData.sGroup > 0) {
            let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`
            axios.get(merchantByGroupId,
                { headers: { 'Authorization': authToken } })
                .then(res => {
                    if (res.status === 200) {
                        const { data } = res.data
                        const locationItems = data.map(g => ({
                            text: g.description,
                            val: g.idMerchant
                        })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                        setSearchLocationMenus(prevData => [
                            ...prevData,
                            ...locationItems
                        ])
                    }
                })
                .catch(err => err)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData.sGroup])

    //#region Search
    const clearFilter = ({ name }, nfilters, searchData) => {
        let filteredData = sprofiles
        //#region filter data
        switch (name) {
            case "sProfileName":
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                    filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
                break;
            case "sGroup":
                if (searchData["sProfileName"] && searchData["sProfileName"].trim() !== '')
                    filteredData = filteredData.filter(u => u.profileName && u.profileName.toLowerCase().includes(searchData["sProfileName"].trim().toLowerCase()))
                const finr = nfilters.filter(f => f.name !== 'sGroup' || f.name !== 'sLocation')
                const fir = nfilters.find(f => f.name === 'sLocation')
                fir.value = ""
                setFilters([fir, ...finr])
                setSearchData(prevData => ({
                    ...prevData,
                    sLocation: ''
                }))
                break;
            case "sLocation":
                if (searchData["sProfileName"] && searchData["sProfileName"].trim() !== '')
                    filteredData = filteredData.filter(u => u.profileName && u.profileName.toLowerCase().includes(searchData["sProfileName"].trim().toLowerCase()))
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                break;
            default: break;
        }
        //#endregion

        //#region clear filter
        const filterItemNotToRemove = nfilters.filter(f => f.name !== name)
        const filterItemToRemove = nfilters.find(f => f.name === name)
        filterItemToRemove.value = ""
        setFilters([filterItemToRemove, ...filterItemNotToRemove])
        //#endregion

        setSearchData(prevData => ({
            ...prevData,
            [name]: ''
        }))
        setProfiles(filteredData)
    }
    const resetFilterData = (nfilters) => {
        setFilters(nfilters.map(item => ({ ...item, value: '' })))
        setSearchData({
            sProfileName: '',
            sGroup: '',
            sLocation: ''
        })
        getAllProfiles()
    }
    const handleChange = (name, value) => {
        setSearchData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }
    const handleSearch = () => {
        setFilters([
            {
                name: "sProfileName",
                value: searchData["sProfileName"],
                remove: clearFilter
            },
            {
                name: "sGroup",
                value: searchData["sGroup"] === '' ? '' : searchGroupsMenus.find(g => g.val === searchData["sGroup"]).text,
                remove: clearFilter
            },
            {
                name: "sLocation",
                value: searchData["sLocation"] === '' ? '' : searchLocationMenus.find(l => l.val === searchData["sLocation"]).text,
                remove: clearFilter
            },
            {
                name: "clear",
                isClearAll: true,
                clearAll: resetFilterData
            }
        ])
        let filteredData = sprofiles
        if ((searchData["sProfileName"].trim() === '') &&
            (searchData["sGroup"] === '' || searchData["sGroup"] < 0) &&
            (searchData["sLocation"] === '' || searchData["sLocation"] < 0))
            resetFilterData(filters)
        else {
            if (searchData["sProfileName"] && searchData["sProfileName"].trim() !== '')
                filteredData = filteredData.filter(u => u.profileName && u.profileName.toLowerCase().includes(searchData["sProfileName"].trim().toLowerCase()))
            if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
            if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
            setProfiles(filteredData)
        }
    }

    const searchOptions = {
        title: Strings.SEARCH_PROFILE_TILTLE,
        spacing: 2,
        searchItems: [
            {
                name: "sProfileName",
                label: Strings.COLUMN_PROFILE_NAME,
                type: "search",
                defaultValue: searchData["sProfileName"],
                onChange: handleChange
            },
            {
                name: "sGroup",
                label: Strings.SEARCH_CASINO_GROUP,
                isSelect: true,
                menuItems: searchGroupsMenus,
                defaultValue: searchData["sGroup"],
                onChange: handleChange
            },
            {
                name: "sLocation",
                label: Strings.SEARCH_CASINO_LOCATION,
                isSelect: true,
                menuItems: searchLocationMenus,
                defaultValue: searchData["sLocation"],
                onChange: handleChange
            }
        ],
        handleSearch
    }
    //#endregion

    const getAllProfiles = () => {
        setIsLoading(true)
        axios.get(profilesEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    setProfiles(data)
                    setSearchProfiles(data)
                }
            })
            .catch(err => err)
            .finally(() => setIsLoading(false))
    }

    const actions = [
        rowData => ({
            icon: rowData.status === 0 ? tableIcons.CheckBoxBlank : tableIcons.CheckBox,
            tooltip: profilePermission.update ? rowData.status === 0 ? 'Activate this Profile' : 'Deactivate this Profile' : 'Permission Denied',
            disabled: !profilePermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                let cnfDesc = rowData.status === 0 ? `This will activate profile ${rowData.name ?? rowData.description}` :
                    `This will deactivate profile ${rowData.name ?? rowData.description}`
                confirm({ description: cnfDesc })
                    .then(() => {
                        let url = rowData.status === 0 ? profilesEndPoints.activateProfileById : profilesEndPoints.deActivateProfileById
                        axios.put(
                            format(url, rowData.idProfile),
                            {},
                            { headers: { 'Authorization': authToken } })
                            .then(res => {
                                if (res.data.success) {
                                    const dataUpdate = [...profiles]
                                    const index = rowData.tableData.id
                                    dataUpdate[index] = res.data.data
                                    setProfiles([...dataUpdate])
                                    resolve()
                                }
                            })
                    })

            })
        }),
        {
            icon: tableIcons.Edit,
            tooltip: profilePermission.update ? 'Edit Profile' : 'Permission Denied',
            disabled: !profilePermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                setIsLoading(true)
                setModalFormResetKeys([])
                let url = format(profilesEndPoints.getProfileById, rowData.idProfile)
                axios.get(url,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.data.success) {
                            const { data } = res.data
                            resolve(data)
                        }
                    })
                    .catch(err => err)
                    .finally(() => setIsLoading(false))
            }).then(data => handleActionClick(event, true, data))
        },
        {
            icon: profilePermission.update ? tableIcons.Permission : tableIcons.View,
            tooltip: profilePermission.update ? 'Edit Permissions' : 'View Permissions',
            onClick: (event, rowData) => new Promise((resolve) => {
                setIsLoading(true)
                setModalFormResetKeys([])
                let url = format(profilesEndPoints.getProfilePermissionsListById, rowData.idProfile)
                axios.get(url,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.data.success) {
                            const { data } = res.data
                            resolve(data)
                        }
                    })
                    .catch(err => err)
                    .finally(() => setIsLoading(false))
            }).then(data => handlePermissionActionClick(rowData.idProfile, profilePermission.update, data))
        }
    ]
    //#region Modal
    useEffect(() => {
        new Promise(resolve => {
            setModalFormResetKeys(["IdMerchant"])
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                IdMerchant: {
                    ...prevContent["IdMerchant"],
                    menuItems: locationMenus
                }
            }))
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationMenus])
    const handleSubmit = (data, isEdit, idProfile) => {
        setModalTaskRunning(true)
        let url = isEdit === true ? format(profilesEndPoints.updateProfile, idProfile) : profilesEndPoints.postProfile
        axios({
            method: isEdit === true ? 'put' : 'post',
            url: url,
            headers: { 'Authorization': authToken },
            data: data
        }).then((res) => {
            const response = res.data
            if (response.success === true) {
                handleModalClose()
                getAllProfiles()
                // Solo al CREAR: recordar que hay que asignar permisos al perfil nuevo.
                if (isEdit !== true) setShowPermissionReminder(true)
            }
            else
                setModalFormError(response.errors)
        })
            .catch(err => err)
            .finally(() => setModalTaskRunning(false))
    }
    const handleSelectionChange = (event) => {
        setGLObj(prevGL => ({
            ...prevGL,
            group: event.target.value
        }))
        new Promise(resolve => {
            setModalFormResetKeys(["IdMerchant"])
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                IdMerchant: {
                    ...prevContent["IdMerchant"],
                    value: '',
                    menuItems: locationMenus
                }
            }))
        )
    }
    const closePermissionReminder = () => setShowPermissionReminder(false)
    const handleModalClose = () => {
        setOpenDialog(false)
        setModalFormError({})
        setGLObj({
            program: '',
            group: '',
            location: ''
        })
        setModalFormResetKeys([])
    }
    const handleActionClick = (event, isEdit = false, rowData = {}) => {
        setModalHeader({
            isForm: true,
            title: isEdit === true ? "Edit Profile" : "Add Profile",
            header: isEdit === true ? "Edit this existing Profile" : "Create a new Profile"
        })
        setModalContent({
            Name: {
                label: "Profile Name",
                size: "small",
                variant: "outlined",
                col: 12,
                value: rowData.name ?? "",
                validator: {
                    required: { value: true, message: "Profile Name is required" }
                }
            },
            Description: {
                label: "Description",
                size: "small",
                variant: "outlined",
                col: 12,
                value: rowData.description ?? "",
                validator: {
                    required: { value: true, message: "Description is required" }
                }
            },
            IdGroup: {
                label: "Group",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: rowData.idGroup ?? '',
                menuItems: groupsMenus,
                validator: {
                    required: { value: true, message: "Please choose a Group" }
                },
                onSelectionChange: handleSelectionChange
            },
            IdMerchant: {
                label: "Location",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: rowData.idMerchant ?? '',
                menuItems: locationMenus,
                validator: {
                    required: { value: true, message: "Please choose a Location" }
                }
            }
        })
        setModalActions([
            {
                label: isEdit === true ? "Update" : "Save",
                icon: isEdit === true ? tableIcons.Edit : tableIcons.Save,
                isSubmit: true,
                action: isEdit === true ? (data) => handleSubmit(data, true, rowData.idProfile) : (data) => handleSubmit(data, false)
            }
        ])
        setOpenDialog(true)
        if (isEdit === true) {
            setGLObj(prevGl => ({
                ...prevGl,
                group: rowData.idGroup,
                location: rowData.idMerchant
            }))
        }
        else setModalFormResetKeys([])
    }
    const handleRowDataChange = (propName, value, rowData) => {
        rowData = { ...profilePermData[rowData.tableData.id], [propName]: value }
        profilePermData.splice(rowData.tableData.id, 1, rowData)
    }
    //#region Permission Modal
    const handlePermissionUpdate = (idProfile) => {
        let requestBody = {
            "permissions": profilePermData.map(item => ({
                "permissionId": item.permissionId,
                "create": item.create,
                "read": item.read,
                "update": item.update,
                "delete": item.delete,
                "special": item.special
            }))
        }
        setModalTaskRunning(true)
        axios.put(
            format(profilesEndPoints.updateProfilePermissionsListById, idProfile),
            requestBody,
            { headers: { 'Authorization': authToken } }
        ).then((res) => {
            const response = res.data
            if (response.success === true) {
                handleModalClose()
                // Solo actualizar el contexto global si el perfil editado
                // es el mismo que el del usuario actualmente logueado
                if (`${idProfile}` === `${authData.context.id_profile}`) {
                    setPermissions(response.data)
                }
            }
            else setModalFormError(response.errors)
        })
            .catch(err => err)
            .finally(() => setModalTaskRunning(false))
    }

    const detailPanel = [
        {
            tooltip: 'View endpoints',
            render: rowData => {
                const routeItems = endRoutes.find(r => `${r.moduleId}` === `${rowData.moduleId}`).routes.map(item => ({ routeId: item.routeId, verb: item.verb.replace(/[^a-zA-Z]/g, ''), endpoint: item.endpoint }))
                return (
                    <>
                        <Typography variant="subtitle2" style={{ margin: '8px 16px 0' }}>
                            {Strings.ENDPOINT_HEADING}
                        </Typography>
                        <List dense>
                            {
                                routeItems.map(item => (
                                    <ListItem key={item.routeId} unselectable='true'>
                                        <ListItemIcon>
                                            <Chip label={item.verb} className={classes[`ch_verb_${item.verb.toLowerCase()}`]} />
                                        </ListItemIcon>
                                        <ListItemText primary={item.endpoint} style={{ marginLeft: 5 }} />
                                    </ListItem>
                                ))
                            }
                        </List>
                    </>
                )
            },
        }
    ]

    const handlePermissionActionClick = (idProfile, canUpdate, pData) => {
        let { perColumns } = permissionDataColumn(canUpdate, handleRowDataChange, `${idProfile}` === `${authData.context.id_profile}`)
        profilePermData = pData
        setModalFormResetKeys([])
        setModalActions([])
        setModalHeader({
            isForm: true,
            title: "Profile Permissions",
            header: canUpdate ? "Edit permissions for this Profile" : "Available permissions for this Profile"
        })
        setModalContent({
            ProfilePermissions: {
                label: "Permission List",
                type: 'table',
                col: 12,
                columns: perColumns,
                data: pData,
                detailPanel: detailPanel,
                tableOptions: {
                    search: false,
                    paging: false,
                    toolbar: false,
                    sorting: false,
                    draggable: false
                }
            }
        })
        if (canUpdate)
            setModalActions([
                {
                    label: "Update",
                    icon: tableIcons.Edit,
                    isSubmit: true,
                    action: (d) => handlePermissionUpdate(idProfile)
                }
            ])
        setOpenDialog(true)
    }
    //#endregion
    //#endregion
    return {
        profiles,
        isLoading,
        getAllProfiles,
        searchOptions,
        columns,
        sytlingOptions,
        actions,
        filters,
        searchData,
        openDialog,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        profilePermission,
        showPermissionReminder,
        closePermissionReminder
    }
}
export default useProfiles